
export default function TSeriesVerificationDirective() {
    return {
        restrict: 'E',
        scope: {},
        controller: 'TSeriesVerficationController',
        template: require('./verification.html'),
    };
}
